import Markdown from '@/components/Markdown'

interface Props {
  sources: string[]
}

const MarkdownPage: React.FC<Props> = ({ sources }) => {
  return (
    <div className="px-6 py-16 sm:px-48">
      {sources.map((source, idx) => (
        <Markdown key={idx} source={source} />
      ))}
    </div>
  )
}

export default MarkdownPage
